import React from "react";
import PageLayout from "../_layout/PageLayout";

import { logoEsicBackground } from "../../components/svg/svgImageList";
import { ViewDashboard } from "../../services/authorization/Permissions";
import Svg from "../../components/svg/Svg";
import LandingPage from "../landing-page/LandingPage";
import { currentUserService } from "../../services/user/CurrentUserStorage";

export default function DashboardPage() {
  if (currentUserService.userIsPartOfAnOrganization) {
    return (
      <PageLayout accessWithOneOfThePermissions={[ViewDashboard]}>
        <Svg
          svg={logoEsicBackground.light}
          width={"50vw"}
          height={"50vh"}
          style={{ marginTop: "150px" }}
        />
      </PageLayout>
    );
  } else {
    return <LandingPage />;
  }
}
